import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { rupiah } from "@/lib/format";
import { F } from "@/pages/Employees";
import { VehicleSelect } from "@/components/vehicle/VehicleServices";
import ExportPreview from "@/components/ExportPreview";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FileText } from "lucide-react";
import { toast } from "sonner";

const monthStart = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`; };

export default function VehicleReport({ vehicles }) {
  const [vid, setVid] = useState("all");
  const [start, setStart] = useState(monthStart());
  const [end, setEnd] = useState("");
  const [data, setData] = useState(null);
  const [pdf, setPdf] = useState(false);
  const qs = new URLSearchParams({ ...(vid !== "all" ? { vehicle_id: vid } : {}), ...(start ? { start } : {}), ...(end ? { end } : {}) }).toString();
  useEffect(() => { api.get(`/vehicle-report?${qs}`).then((r) => setData(r.data)).catch((e) => toast.error(apiErr(e))); }, [qs]);
  const Stat = ({ label, value, testid, tone }) => (
    <Card className={`p-4 ${tone}`}><div className="text-xs font-semibold opacity-80">{label}</div><div className="mt-1 text-xl font-black font-mono" data-testid={testid}>{value}</div></Card>
  );
  return (
    <div className="space-y-4">
      <Card className="p-4 grid grid-cols-1 sm:grid-cols-4 gap-3 items-end">
        <F label="Kendaraan"><VehicleSelect vehicles={vehicles} value={vid} onChange={setVid} testid="vrep-vehicle" all /></F>
        <F label="Dari"><Input type="date" value={start} onChange={(e) => setStart(e.target.value)} data-testid="vrep-start" /></F>
        <F label="Sampai"><Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} data-testid="vrep-end" /></F>
        <Button className="bg-blue-800 hover:bg-blue-900" onClick={() => setPdf(true)} data-testid="vrep-pdf-btn"><FileText className="h-4 w-4 mr-1" /> Pratinjau & Unduh PDF</Button>
      </Card>
      {data && <>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          <Stat label="Biaya Perawatan & Service" value={rupiah(data.total_service)} testid="vrep-total-service" tone="bg-blue-900 text-white" />
          <Stat label="Biaya BBM" value={rupiah(data.total_bbm)} testid="vrep-total-bbm" tone="bg-orange-500 text-white" />
          <Stat label="Total Biaya Kendaraan" value={rupiah(data.total_service + data.total_bbm)} testid="vrep-total" tone="bg-white" />
        </div>
        <Card className="p-0 overflow-x-auto scroll-thin">
          <table className="w-full text-sm" data-testid="vrep-table">
            <thead><tr className="bg-blue-900 text-white text-xs uppercase">
              {["Plat No", "Jenis", "Service", "Biaya Service", "Isi BBM", "Liter", "Biaya BBM", "Total"].map((h) => <th key={h} className="px-3 py-2.5 text-left">{h}</th>)}
            </tr></thead>
            <tbody>
              {data.per_kendaraan.length === 0 && <tr><td colSpan={8} className="py-10 text-center text-slate-400">Tidak ada biaya di rentang ini.</td></tr>}
              {data.per_kendaraan.map((r, i) => (
                <tr key={r.vehicle_id} className="border-b border-slate-100" data-testid={`vrep-row-${i}`}>
                  <td className="px-3 py-2 font-mono font-bold">{r.plat_no}</td><td className="px-3 py-2">{r.jenis}</td>
                  <td className="px-3 py-2">{r.n_service}x</td><td className="px-3 py-2 font-mono">{rupiah(r.service)}</td>
                  <td className="px-3 py-2">{r.n_bbm}x</td><td className="px-3 py-2 font-mono">{r.liter.toLocaleString("id-ID")}</td>
                  <td className="px-3 py-2 font-mono">{rupiah(r.bbm)}</td><td className="px-3 py-2 font-mono font-bold">{rupiah(r.total)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      </>}
      <ExportPreview open={pdf} onClose={() => setPdf(false)} title="Pratinjau Laporan Kendaraan" pdfUrl={pdf ? `/vehicle-report/pdf?${qs}` : null}
        items={[{ label: "Unduh PDF", url: `/vehicle-report/pdf?${qs}`, filename: "laporan_kendaraan.pdf" }]} />
    </div>
  );
}
